module.exports = __webpack_public_path__ + "static/img/__9107.997dfd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9107.jpg
// module id = e1Qb
// module chunks = 0